
import NativeClient from "@/client/native-client";
import {
  Content,
  DishItem,
  Theme,
  Variation,
  RECIPE_DROPDOWN_TYPE
} from "@/types/recipes";
import { DropdownItem } from "@/types/search";
import {
  defineComponent,
  SetupContext,
  computed,
  PropType,
  ref,
  onMounted,
  nextTick
} from "vue";
import DetailDishItem from "./DetailDishItem.vue";
import RecipeDropdownList from "./RecipeDropdownList.vue";

export default defineComponent({
  components: { DetailDishItem, RecipeDropdownList },
  name: "DetailIngredinetsView",
  props: {
    content: {
      type: Content
    },
    themeList: {
      type: Array as PropType<Theme[]>,
      default: () => null
    },
    varicationList: {
      type: Array as PropType<Variation[]>,
      default: () => null
    },
    selectThemeType: {
      type: String,
      required: true
    },
    selectVariationType: {
      type: String,
      required: true
    },
    isShowDialog: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    const themeType = RECIPE_DROPDOWN_TYPE.THEME;
    const variationType = RECIPE_DROPDOWN_TYPE.VARIATION;
    NativeClient.sendDebugLog(
      "DetailIngredinetsView selectVariationTypeString=" +
        props.selectVariationType
    );
    const getDishes = () => {
      const items = Array<DishItem>();
      if (props.content && props.content.dishes) {
        for (let i = 0; i < props.content.dishes.length; i++) {
          items.push(
            new DishItem(
              i,
              props.content.dishes[i],
              props.content.dishes[i].ingredients
            )
          );
        }
      }
      return items;
    };

    const getThemeDrowDownList = () => {
      const items = Array<DropdownItem>();
      if (props.themeList) {
        for (let i = 0; i < props.themeList.length; i++) {
          const theme = props.themeList[i];
          if (theme.themeId == 0) {
            continue;
          }
          const item = new DropdownItem();
          item.id = theme.themeId;
          item.label = theme.themeName;
          item.type = theme.themeName;
          items.push(item);
        }
      }
      return items;
    };

    const isShowTheme = () => {
      const items = getThemeDrowDownList();
      NativeClient.sendDebugLog("DetailIngredinetsView isShowTheme items=" + JSON.stringify(items));
      return items.length >= 1;
    };

    const getVariationDrowDownList = () => {
      const items = Array<DropdownItem>();
      if (props.varicationList) {
        for (let i = 0; i < props.varicationList.length; i++) {
          const variation = props.varicationList[i];
          const item = new DropdownItem();
          item.id = variation.num;
          item.label = variation.unit;
          item.type = variation.unit;
          items.push(item);
        }
      }
      return items;
    };

    const isShowVariation = () => {
      const items = getVariationDrowDownList();
      NativeClient.sendDebugLog("DetailIngredinetsView isShowVariation items=" + JSON.stringify(items));
      return items.length >= 1;
    };

    const getSelectThemeType = () => {
      return props.selectThemeType;
    };

    const getSelectVariationType = () => {
      return props.selectVariationType;
    };

    const clickTheme = (type: string) => {
      context.emit("click-theme", type);
    };

    const clickVariation = (type: string) => {
      context.emit("click-variation", type);
    };

    return {
      getDishes,
      getThemeDrowDownList,
      getVariationDrowDownList,
      isShowTheme,
      isShowVariation,
      themeType,
      variationType,
      getSelectThemeType,
      getSelectVariationType,
      clickTheme,
      clickVariation
    };
  }
});
